import apiService from "../../api/api.service";
import {
  RegisterRequest,
  RegisterResponse,
  LoginSendCodeRequest,
  LoginVerifyCodeRequest,
  LoginResponse,
  LogoutResponse,
  DeleteAccountResponse,
  UserProfileResponse,
} from "./auth.types";

export const fetchRegisterSendCode = async (
  data: RegisterRequest,
): Promise<RegisterResponse> => {
  return apiService.post<RegisterResponse, RegisterRequest>(
    "/auth/register",
    data,
  );
};

export const fetchRegisterVerifyCode = async (
  data: RegisterRequest,
): Promise<RegisterResponse> => {
  return apiService.post<RegisterResponse, RegisterRequest>(
    "/auth/register",
    data,
  );
};

export const fetchLoginSendCode = async (
  data: LoginSendCodeRequest,
): Promise<LoginResponse> => {
  return apiService.post<LoginResponse, LoginSendCodeRequest>(
    "/auth/login",
    data,
  );
};

export const fetchLoginVerifyCode = async (
  data: LoginVerifyCodeRequest,
): Promise<LoginResponse> => {
  return apiService.post<LoginResponse, LoginVerifyCodeRequest>(
    "/auth/login",
    data,
  );
};

export const fetchLogout = async (): Promise<LogoutResponse> => {
  return apiService.post<LogoutResponse>("/auth/logout");
};

export const fetchDeleteAccount = async (): Promise<DeleteAccountResponse> => {
  return apiService.post<DeleteAccountResponse>("/auth/delete");
};

export const fetchUserProfile = async (): Promise<UserProfileResponse> => {
  return apiService.get<UserProfileResponse>("/auth/me");
};
